import { render, staticRenderFns } from "./AvisPreview.vue?vue&type=template&id=12da7386&"
import script from "./AvisPreview.vue?vue&type=script&lang=js&"
export * from "./AvisPreview.vue?vue&type=script&lang=js&"
import style0 from "./AvisPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports